"use client";

import { c as _c } from "react/compiler-runtime";
import { MicOff } from "lucide-react";
import { cn } from "@/lib/utils";
import type { RosterFace } from "../model/meeting-roster";

/** Small avatar for the floating panel — name shown on hover (title). */
export function PanelFace(t0) {
  const $ = _c(15);
  const {
    face
  } = t0;
  const speaking = face.speaking && !face.muted;
  const t1 = face.name;
  let t2;
  if ($[0] !== speaking) {
    t2 = speaking ? <span aria-hidden={true} className="absolute inset-0 animate-ping rounded-full bg-[#5651ff]/25 motion-reduce:animate-none" /> : null;
    $[0] = speaking;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = speaking ? "bg-[#5651ff]/20 text-white shadow-[0_0_0_2px_rgba(86,81,255,0.8),0_2px_10px_rgba(86,81,255,0.4)]" : "bg-white/8 text-white/75";
  let t4;
  if ($[2] !== t3) {
    t4 = cn("relative flex h-10 w-10 items-center justify-center rounded-full text-xs font-semibold transition-all", t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== face.monogram || $[5] !== speaking || $[6] !== t4) {
    t5 = <span data-speaking={speaking} className={t4}>{face.monogram}</span>;
    $[4] = face.monogram;
    $[5] = speaking;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== face.muted) {
    t6 = face.muted ? <span aria-label="Muted" className="absolute -bottom-0.5 -right-0.5 flex h-4 w-4 items-center justify-center rounded-full bg-[#1a2036] text-white/80 ring-2 ring-[#0b1020]"><MicOff className="h-2 w-2" aria-hidden={true} /></span> : null;
    $[8] = face.muted;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== face.name || $[11] !== t2 || $[12] !== t5 || $[13] !== t6) {
    t7 = <span className="relative flex h-10 w-10 items-center justify-center" title={t1}>{t2}{t5}{t6}</span>;
    $[10] = face.name;
    $[11] = t2;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}